import React, { useEffect, useRef, useState } from "react";
import BannerOverlay from "../BannerOverlay/BannerOverlay";
import useVideoSource from "@arctheme-hooks/useVideoSourceQuality";
import useInViewVideo from "@arctheme-hooks/useInViewVideo";

const BannerVideo = ({
  blockItem,
  section_settings,
  isMobile,
  index,
  banners,
  globals
}) => {
  const [videoSources, setVideoSources]: any = useState([]);
  const [videoPlaying, setVideoPlaying]: any = useState(
    Array(banners.length).fill(false),
  );
  const videoRefs: any = useRef([]);
  const { videoRef, isPlaying, setupObserver } = useInViewVideo();

  const showControls = blockItem.settings.show_controls;
  const videoUrlDefined = blockItem.settings.video_url?.length > 0; // Check if a video URL is defined

  const newVideoSources = banners.map((blockItem) => {
    if (blockItem.type === "block_video") {

      const videoSettings = isMobile && blockItem.settings?.video_mobile
          ? blockItem.settings?.video_mobile
          : blockItem.settings?.video;

      const videoSources = videoSettings?.sources;
      // Call the hook to get video URL and poster for each video block
      const { videoUrl, videoPoster } = useVideoSource(
          videoSources,
          videoSettings.preview_image,
          isMobile,
          globals.video_quality
      );

      return { videoUrl, videoPoster };
    }
    return null;
  });

  useEffect(() => {
    setVideoSources(newVideoSources);
    const timeoutId = setTimeout(() => {
      setupObserver(videoRef);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isMobile, banners]);

  useEffect(() => {
    banners.forEach((blockItem, index) => {
      if (blockItem.type === "block_video" && videoRefs.current[index]) {
        const videoElement = document.querySelector(`#video-${index}`);
        videoRefs.current[index] = videoElement;
      }
    });
  }, [banners]);

  const handlePlayButtonClick = (index) => {
    const updatedVideoPlaying = [...videoPlaying];
    updatedVideoPlaying[index] = true;
    setVideoPlaying(updatedVideoPlaying);

    const videoElement: any = videoRefs.current[index];
    if (videoElement) {
      videoElement.play();
    }
  };

  const VideoContent = () => (
      <div className={`h-full w-full`}>
        <video
            id={`video-${index}`}
            ref={videoRef}
            muted
            // ${videoPlaying[index] || blockItem.settings.should_autoplay ? "" : ""}
            controls={!videoPlaying[index] && showControls && !blockItem.settings.should_autoplay ? true : false}
            loop={blockItem.settings.should_loop ? true : false}
            className="object-cover h-full w-full"
            // poster={`${videoSources[index]?.videoPoster || ""}`}
            preload="metadata"
            playsInline>
          <source src={`${videoSources[index]?.videoUrl || ""}`} type="video/mp4"/>
        </video>
      </div>
  );

  return (
    <>
      {blockItem.settings.show_overlay &&
        (videoUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.video_url}
            className="absolute h-full w-full block"
          >
            <BannerOverlay
              blockItem={blockItem}
              section_settings={section_settings}
              isMobile={isMobile}
            />
          </a>
        ) : (
          <BannerOverlay
            blockItem={blockItem}
            section_settings={section_settings}
            isMobile={isMobile}
          />
        ))}
      <div
        className={`flex h-full w-full ${blockItem.settings.darken_image && "content-over-media"} relative`}
      >
        {videoUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.video_url}
            className="h-full w-full block"
          >
            <VideoContent />
          </a>
        ) : (
          <VideoContent />
        )}

        {!videoPlaying[index] && !blockItem.settings.should_autoplay && (
          <div
            className={
              "absolute flex justify-center h-full w-full items-center"
            }
          >
            <button
              className="relative flex items-center justify-center text-black fill-black bg-[#e5e7eb] rounded-full w-[50px] h-[50px]"
              onClick={() => handlePlayButtonClick(index)}
            >
              <i className={"icon icon-play text-black"}></i>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default BannerVideo;
